//@ts-nocheck
import React, { useState } from "react";

import { useDropzone } from "react-dropzone";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import MDTypography from "../MDTypography";

interface Props {
  onDropFile: (files: File[]) => void;
}

const MDDropzone = ({ title, onDropFile }: Props): JSX.Element => {
  const [files, setFiles] = useState<File[]>([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles: File[]) => {
      setFiles(acceptedFiles);
      if (onDropFile) {
        onDropFile(acceptedFiles);
      }
    },
    maxFiles: 40,
    multiple: true,
  });

  return (
    <MDBox
      {...getRootProps()}
      className={`dropzone-container ${darkMode ? "dark-mode" : ""}`}
      style={{
        border: "2px dashed rgb(47, 146, 159)",
        padding: "8px",
        textAlign: "center",
        minHeight: "10px",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "0.375rem",
      }}
    >
      <input {...getInputProps()} />
      <MDTypography
        sx={{ color: "rgb(47, 146, 159) !important", fontSize: "1rem !important", fontWeight: 500 }}
      >
        {title}
      </MDTypography>
    </MDBox>
  );
};

export default MDDropzone;
